import { Routes, Route } from "react-router-dom";
import ClientLayout from "../layouts/ClientLayout";
import TaskBoardWrapper from "../pages/client/TaskBoardWrapper";
import TicketDetailCard from "../pages/client/PageDetail";
import TicketForm from "../pages/client/AddTaskForm";
import Index from "../auth/Index";

const clientRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<ClientLayout />}>
                <Route path="home" element={<TaskBoardWrapper />} />
                <Route path="/task/:id" element={< TicketDetailCard/>} />
                <Route path="task/create" element={<TicketForm />} />
                <Route index element={<Index />} />
            </Route>
        </Routes>
    );
};

export default clientRoutes;
